import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_menu_ultimate_champion",
  "use": "icon_menu_ultimate_champion-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_menu_ultimate_champion\"><path d=\"M0 8V4h2.857v4H0zm3.571 0V2H6.43v6H3.57zm3.572 0V5.333H10V8H7.143z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol